import { format, setISODay } from 'date-fns'
import { PUBLIC_HOLIDAY_WEEKDAY_CONST } from '../enums'

export const getWeekdayString = (day: number | string): string => {
  switch (typeof day) {
    case 'number':
      return formatNumberToWeekday(day)
    case 'string':
      if (isNaN(Number(day))) return day
      return formatNumberToWeekday(Number(day))
    default:
      return formatNumberToWeekday(Number(day))
  }
}

const formatNumberToWeekday = (day: number): string => {
  switch (day) {
    case PUBLIC_HOLIDAY_WEEKDAY_CONST:
      return 'Feiertag'
    default:
      return format(setISODay(new Date(), day), 'EEEEEE')
  }
}

export const weekdaysSelections = [
  { value: 1, weekday: 'Mo' },
  { value: 2, weekday: 'Di' },
  { value: 3, weekday: 'Mi' },
  { value: 4, weekday: 'Do' },
  { value: 5, weekday: 'Fr' },
  { value: 6, weekday: 'Sa' },
  { value: 0, weekday: 'So' },
]

export const weekdaysWithHoliydaySelections = [
  ...weekdaysSelections,
  { value: PUBLIC_HOLIDAY_WEEKDAY_CONST, weekday: 'Feiertag' },
]
